import React from 'react';

import { TextButton } from '@thefarmersfront/kitchen';

import type { CustomCellRendererProps } from 'ag-grid-react';

import type { TypeOrders } from '~/types/order.types';

import styles from './OrdersOutboundCodeCellRenderer.module.scss';

type TypeOrdersOutboundCodeCellRendererParams = {
  onClick: (orderCode: string) => Promise<void>;
};

type TypeOrdersOutboundCodeCellRendererProps = TypeOrdersOutboundCodeCellRendererParams &
  CustomCellRendererProps<TypeOrders, TypeOrders['outbound']['outboundCode']>;

const OrdersOutboundCodeCellRenderer = ({ onClick, ...params }: TypeOrdersOutboundCodeCellRendererProps) => {
  const { value } = params;
  if (!value) return '-';

  return (
    <TextButton className={styles['text-button']} size="tiny" variant="underline" onClick={() => onClick(value)}>
      {value}
    </TextButton>
  );
};

export default OrdersOutboundCodeCellRenderer;
